import React, { useState, useEffect, useRef } from 'react';
import './create-eval-form.styles.scss'

import { useSelector, useDispatch } from 'react-redux'
import { setEvalList } from '@/state/slices/listsSlice';

import { FormTypes, Sources } from '@/forms/formTypes'
import UIkit from 'uikit'

import { UseCloudFunction } from '@/utils/firebase.utils'
import { RandomString } from '@/utils/randomString'
import flatpickr from 'flatpickr';
import { useParams } from 'react-router-dom';
import { getEvalDataFromDb } from '../../../utils/getDataFromDb';

const CreateEvalForm = ({
  evalList
}) => {

  const [formData, setFormData] = useState({});
  const [resultList, setResultList] = useState(null);
  const [nextUrl, setNextUrl] = useState(null);
  const [formComplete, setFormComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { evalId } = useParams();
  const dataRef = useRef({
    'hours': 0,
    'cpdu': false,
    'isbe': true
  });
  const dispatch = useDispatch()
  let evalListener;

  useEffect(() => {

    return () => {
      if (evalListener) evalListener();
    }
  }, [])

  useEffect(() => {
    if (!evalId) return;
    getEvalData();
  }, [evalId])

  function getEvalData() {
    getEvalDataFromDb({
      'evalId': evalId,
      'callback': callback,
      'handleListener': handleListener
    });
    function callback(data) {
      console.log(data);
    }
    function handleListener(unsub) {
      evalListener = unsub;
    }
  }

  function saveData(value, key) {
    console.log(value, key)
    if (key === 'source') {
      setResultList(null)
      dataRef.current = {
        ...{
          [key]: value,
          'platform': dataRef.current.platform ?? null,
          'hours': 0,
          'cpdu': false,
          'isbe': true
        }
      }
      if (value === 'custom' || value === 'checkinout') {
        setFormData({ ...dataRef.current, ...{ 'custom': true, 'type': value } });
      } else {
        setFormData(dataRef.current);
      }
      return;
    }
    if (value === '' && key !== 'cpdu') {
      if (key === 'title' || key === 'description') {
        delete dataRef.current.item[key]
      } else {
        delete dataRef.current[key];
      }
      setFormData({ ...dataRef.current })
      return;
    }
    if (key === 'hours') {
      value = Number(value)
    }

    if (key === 'title' || key === 'description') {
      const newItemObj = { ...dataRef.current.item, ...{ [key]: value } }
      const newKey = 'item';
      dataRef.current = { ...dataRef.current, ...{ [newKey]: newItemObj } }
      setFormData({ ...dataRef.current });
      return;
    }
    dataRef.current = { ...dataRef.current, ...{ [key]: value } }
    setFormData({ ...dataRef.current });
    // console.log(formData)

  }

  useEffect(() => {
    if (!formData) return;
    // console.log(stateRef.current)
    console.log(formData);
    if (
      formData.platform &&
      formData.source &&
      formData.customEval &&
      formData.item &&
      formData.item.title &&
      (
        formData.source === 'checkinout' && formData.eventDate
      )
    ) {
      setFormComplete(true)
    } else {
      setFormComplete(false)
    }
    if (formData?.source === 'checkinout') {
      const date1Element = document.getElementById('date1')
      if (!date1Element) return;
      let fp1 = flatpickr(date1Element,
        {
          altInput: true,
          altFormat: "F j, Y",
          dateFormat: "Y-m-d",
          onChange: (dates) => { saveData(new Date(dates[0]).getTime(), 'eventDate') }
        }
      );
    }
  }, [formData])

  async function search() {
    setLoading(true);
    delete dataRef.current.comps
    delete dataRef.current.item
    delete dataRef.current.itemId
    delete dataRef.current.type
    setFormData({
      ...dataRef.current, ...{
        'cpdu': false,
        'hours': 0
      }
    });
    setResultList(null)
    const source = dataRef.current.source;
    if (source === 'bridge') {
      const text = document.getElementById('search-text').value;
      console.log(text)
      const url = `https://eln.bridgeapp.com/api/learner/library_items?search=${text}&sort=title`
      const res = await UseCloudFunction('getBridgeCourses', { 'url': url })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList(res.library_items)
      setLoading(false);
    } else if (source === 'odaa') {
      let text = 'AA';
      console.log(text)
      const url = `https://eln.bridgeapp.com/api/author/programs?search=${text}&sort=newest`
      const res = await UseCloudFunction('getBridgePrograms', { 'url': url })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList(res.programs)
      setLoading(false);
    } else if (source === 'zoomWebinar') {
      let url = `https://api.zoom.us/v2/users/arlin@ilprincipals.org/webinars`

      let res = await UseCloudFunction('getZoomWebinars', { 'url': url })
      console.log(res)
      if (res.results.nextPageToken) {
        setNextUrl(res.results.nextPageToken)
      } else {
        setNextUrl(null)
      }
      let arr = []
      for (let web of res.results.webinars) {
        arr.push({
          'id': web.id,
          'title': web.topic,
          'date': new Date(web.start_time).getTime(),
          'description': web.agenda
        })
      }

      url = `https://api.zoom.us/v2/users/arlin@ilprincipals.org/meetings`

      res = await UseCloudFunction('getZoomWebinars', { 'url': url })
      console.log(res)
      if (res.results.nextPageToken) {
        setNextUrl(res.results.nextPageToken)
      } else {
        setNextUrl(null)
      }

      for (let web of res.results.meetings) {
        arr.push({
          'id': web.id,
          'title': web.topic,
          'date': new Date(web.start_time).getTime(),
          'description': web.agenda
        })
      }
      arr.sort((a, b) => a.date < b.date ? 1 : -1)
      setResultList(arr)
      setLoading(false);
    } else if (source === 'mc') {
      let res = await UseCloudFunction('getMCs', { 'url': 'data' })
      console.log(res)
      let arr = [];
      for (let mc of res.list) {
        arr.push({
          'id': mc.mer_prd_key,
          'title': mc.prd_name,
          'date': new Date(mc.prd_add_date).getTime(),
          'description': mc.prd_description
        })
      }
      arr.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1)
      setResultList(arr)
      setLoading(false);
    }
  }

  async function getMoreResults() {
    setLoading(true)
    const source = formData.source;
    if (source === 'bridge') {
      const res = await UseCloudFunction('getBridgeCourses', { 'url': nextUrl })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList([...resultList, ...res.library_items])
      setLoading(false)
    }
    if (source === 'aa') {
      const res = await UseCloudFunction('getBridgePrograms', { 'url': nextUrl })
      console.log(res)
      if (res.meta.next) {
        setNextUrl(res.meta.next)
      } else {
        setNextUrl(null)
      }
      setResultList([...resultList, ...res.programs])
      setLoading(false)
    }
  }

  function chooseItem(id) {

    const items = document.getElementsByClassName('result-list-item')
    for (let i of items) {
      i.classList.remove('selected')
    }
    document.getElementById(id).classList.add('selected')
    let item;
    for (let r of resultList) {
      if (`${dataRef.current.source}-${r.id}` === `${dataRef.current.source}-${id}`) {
        item = r
      }
    }
    dataRef.current = {
      ...dataRef.current, ...{
        'item': item,
        'itemId': `${dataRef.current.source}-${id}`
      }
    };
    setFormData({ ...dataRef.current });
  }

  async function saveEvaluation() {

    console.log(dataRef.current)
    const obj = { ...dataRef.current }

    if (!dataRef.current.id) {
      obj.id = RandomString(14);
    }
    if (
      obj.source === 'checkinout' ||
      obj.source === 'custom'
    ) {
      obj.itemId = `${obj.source}-c${obj.id}`
    } else {
      for (let r of resultList) {
        console.log(r)
        if (r.id === formData.itemId) {
          obj.item = r
          break;
        }
      }
    }
    console.log(obj)
    // return;

    obj.ts = new Date().getTime();
    console.log(obj)
    const res = await UseCloudFunction('saveAdminEval', { 'obj': obj })
    console.log(res)
    if (res.message === 'eval saved successfully') {
      UIkit.modal.alert('Evaluation saved successfully!')
        .then(() => {
          dataRef.current = {
            'hours': 0,
            'cpdu': false,
            'isbe': true
          }
          setFormData({ ...dataRef.current });
          dispatch(setEvalList({
            ...evalList,
            ...{
              [obj.id]: {
                'cpdu': obj.cpdu,
                'hours': obj.hours,
                'id': obj.id,
                'title': obj.item.title,
                'ts': obj.ts,
                'type': obj.type,
                'source': obj.source
              }
            }
          }))
          const searchText = document.getElementById('search-text');
          if (searchText) {
            searchText.value = ''
          }
        })
    } else if (res.message === 'eval already exists') {
      UIkit.modal.alert('An evaluation already exists for this event.')
    } else {
      UIkit.modal.alert('Something went wrong...')
    }
  }

  return (
    <div className='new-eval-form'>
      <div className='uk-margin'>
        <label>Professional Development Platform</label>
        <select
          className="uk-select"
          aria-label="Select a Platform"
          value={formData.platform ?? ''}
          onChange={(e) => saveData(e.target.value, 'platform')}>
          <option value=''>Choose...</option>
          <option value='eln'>Ed Leaders Network</option>
          <option value='ipa'>Illinois Principals Association</option>
        </select>
      </div>
      {
        (formData.platform) &&
        <div className="uk-margin">
          <label>Choose a Source</label>
          <select
            className="uk-select"
            aria-label="Select a Source"
            value={(formData && formData.source) ? formData.source : ''}
            onChange={(e) => saveData(e.target.value, 'source')} >
            <option value=''>Choose...</option>
            {
              (Sources)
                ?
                Object.values(Sources)
                  .sort((a, b) => (a.title > b.title) ? 1 : -1)
                  .filter(a => a.cat.includes(formData.platform))
                  .map(source => (
                    <option
                      key={source.id}
                      value={source.id}>
                      {source.title}
                    </option>
                  ))
                : ''
            }
            <option value='custom'>Custom Evaluation</option>
          </select>
        </div>
      }

      {
        (
          formData &&
          (
            formData.source === 'bridge' ||
            formData.source === 'mc' ||
            formData.source === 'odaa' ||
            formData.source === 'ipaa' ||
            formData.source === 'zoomWebinar'
          )
        ) &&
        <div>
          <div className="uk-margin">

            {
              (formData && (formData.source === 'bridge')) &&
              <>
                <label>Find an Event to Evaluate</label>
                <input
                  className="uk-input"
                  id='search-text'
                  aria-label="Search for an Event to Evaluate" />
              </>
            }
            <button
              className='g-button button-small'
              id='search-button'
              onClick={() => search()}>
              Search
            </button>
          </div>

          {
            (resultList && (!formData || !formData.itemId))
              ?
              <div
                className='result-card result-list'
                id='search-results'>
                {
                  resultList.map(r => (
                    <div
                      key={r.id}
                      className='result-list-item'
                      id={r.id}
                      onClick={(e) => chooseItem(e.target.id)}>
                      {r.title}
                    </div>
                  ))
                }
                {
                  (nextUrl)
                    ?
                    <div
                      className='result-list-item'
                      onClick={() => getMoreResults()}>
                      <b>Load more...</b>
                    </div>
                    : ''
                }

              </div>
              : ''
          }
        </div>
      }


      {
        (
          formData &&
          (
            (formData.itemId && formData.item) ||
            formData.source === 'custom' ||
            formData.source === 'checkinout' ||
            formData.source === 'coach'
          )
        )
          ?
          <>
            {
              (
                !formData.custom &&
                !formData.source === 'checkinout' &&
                formData.item
              ) &&
              <div className='uk-margin-large'>
                <h4><b>{formData.item.title}</b></h4>
                <p>{formData.item.description}</p>
              </div>
            }

            {
              (
                formData.custom ||
                formData.source === 'checkinout' ||
                formData.source === 'coach'
              ) &&
              <div>
                <div className='uk-margin'>
                  <label>Title</label><br />
                  <input
                    className="uk-input"
                    type='text'
                    id='title'
                    aria-label="Name of Presenter"
                    value={
                      (formData && formData.item && formData.item.title)
                        ? formData.item.title
                        : ''
                    }
                    onChange={(e) => saveData(e.target.value, 'title')} />
                </div>

                {/* {
                                (formData.source !== 'coach' && !formData.source.includes('checkinout')) &&
                                <div className='uk-margin'>
                                    <label>Include Custom Evaluation</label><br />
                                    <select 
										className="uk-select" 
										aria-label="Select a Source" 
										value={
											(formData && formData.customSource) 
											? formData.customSource 
											: ''
										} 
										onChange={(e) => saveData(e.target.value, 'customSource')}>
                                        <option value=''>Choose...</option>
                                        {
                                            (Sources)
                                            ?
                                            Object.values(Sources)
                                            .sort((a,b) => (a.title > b.title) ? 1 : -1)
											// .filter(a => a.id !== 'checkinout')
                                            .map(source => (
                                                <option 
													key={source.id} 
													value={source.id}>
													{source.title}
												</option>
                                            ))
                                            : ''
                                        }
                                    </select>
                                </div>
                            }  */}
                {
                  (formData.source.includes('checkinout')) &&
                  <div className='uk-margin'>
                    <label>Date of Event</label><br />
                    <input
                      className="uk-input flatpickr flatpickr-input"
                      type="text"
                      id="date1"
                      placeholder="Pick a date..." />
                  </div>
                }
                <div className='uk-margin'>
                  <label>Description</label><br />
                  <input
                    className="uk-input"
                    type='text'
                    id='description'
                    aria-label="Name of Presenter"
                    value={
                      (
                        formData &&
                        formData.item &&
                        formData.item.description
                      )
                        ? formData.item.description
                        : ''
                    }
                    onChange={(e) => saveData(e.target.value, 'description')} />
                </div>
              </div>
            }
            {
              (
                formData.source !== 'coach' &&
                formData.source !== 'event' &&
                formData.source !== 'checkinout'
              ) &&
              <div className='uk-margin'>
                <label>Presenter(s)</label><br />
                <input
                  className="uk-input"
                  type='text'
                  id='presenters'
                  aria-label="Name of Presenter"
                  value={
                    (formData && formData.pres)
                      ? formData.pres
                      : ''
                  }
                  onChange={(e) => saveData(e.target.value, 'pres')} />
              </div>
            }

            <div className="uk-margin">
              <label>Include a Custom Evaluation</label>
              <select
                className="uk-select"
                aria-label="Include a Custom Evaluation"
                value={
                  (formData && formData.customEval)
                    ? formData.customEval
                    : ''
                }
                onChange={(e) => saveData(e.target.value, 'customEval')}>
                <option value=''>Choose...</option>
                <option value='none'>No Custom Evaluation</option>
                {
                  (FormTypes)
                    ?
                    Object.values(FormTypes)
                      .sort((a, b) => (a.title > b.title) ? 1 : -1)
                      .map(type => (
                        <option
                          key={type.id}
                          value={type.id}>
                          {type.title}
                        </option>
                      ))
                    : ''
                }


              </select>
            </div>
            <div className='uk-margin inline-checkbox'>
              <label>Include ISBE Evaluation</label>
              <input
                className="uk-checkbox"
                type="checkbox"
                checked={formData.isbe ? true : false}
                onChange={(e) => saveData(e.target.checked, 'isbe')}
              />
            </div>

            <div className='uk-margin inline-checkbox'>
              <label>Create Evidence of Completion Document</label>
              <input
                className="uk-checkbox"
                type="checkbox"
                defaultChecked={false}
                onClick={(e) => saveData(e.target.checked, 'cpdu')} />
            </div>
            {
              (formData && formData.cpdu)
                ?
                <div className='uk-margin'>
                  <label>Number of Hours for Evidence</label><br />
                  <input
                    className="uk-input uk-form-width-small"
                    type='number'
                    id='hours'
                    aria-label="Number of hours"
                    value={
                      (formData && formData.hours)
                        ? formData.hours
                        : 0
                    }
                    onChange={(e) => saveData(e.target.value, 'hours')} />
                </div>
                : ''
            }
          </>
          : ''
      }
      {
        (loading) &&
        <div className='loader'>
          <div data-uk-spinner='ratio: 2'></div>
        </div>
      }
      <div className='buttons'>
        <button
          className={`g-button blue ${formComplete ? '' : 'disabled'}`}
          onClick={() => saveEvaluation()}>
          Save Evaluation
        </button>
      </div>
    </div>
  )
}

export default CreateEvalForm;